// P2b tanda 3d — clasificador del error de guardado en WooCommerce (defecto 3
// de la revisión de 3c). Decide por el CÓDIGO de Woo primero; el mensaje solo
// respalda cuando NOMBRA al SKU. Un not_created sin mención de SKU queda como
// error genérico: ese código envuelve varias causas, y decir "abrí el
// existente" sobre otra causa manda a arreglar la equivocada.
export function esErrorDeSkuDuplicado(err) {
  if (!err) return false;
  const code = err.code || '';
  const msg = String(err.message || '');
  if (code === 'product_invalid_sku') return true;
  const nombraSku = /sku/i.test(msg);
  if (code === 'woocommerce_rest_product_not_created') return nombraSku;
  return nombraSku && /(ya (está|existe)|duplicad|lookup table|tabla de búsqueda)/i.test(msg);
}
